import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StateStoreService } from '../services/state-store/state-store';

/**
 * Restricts the route to users whose currently-selected organisation is a
 * MANAGER or SUPER_MANAGER.
 *
 * Use this for the customer-managing surface (Customers tab, cross-customer
 * review queue). Use {@link complianceGuard} for the broader compliance
 * surface (frameworks, controls, AI import) that SELF_MANAGED orgs also
 * access — strictly on their own org.
 *
 * Readiness is guaranteed by `appReadyMatch` at the route level.
 */
export const managerGuard: CanActivateFn = () => {
  const state = inject(StateStoreService);
  const router = inject(Router);

  return state.isManagerOrSuperManager() ? true : router.createUrlTree(['/assessment']);
};

/**
 * Capability gate for the manager-class compliance surface — frameworks,
 * controls (write), AI import, vendor management beyond the basic STANDARD
 * surface. Mirrors the BE `profile.can_manage_compliance` predicate.
 *
 * Permits MANAGER, SUPER_MANAGER, and SELF_MANAGED. STANDARD is blocked.
 *
 * Scope (which org the action targets) is enforced server-side per request,
 * so this guard's job is purely to keep the menu items reachable.
 */
export const complianceGuard: CanActivateFn = () => {
  const state = inject(StateStoreService);
  const router = inject(Router);

  return state.canManageCompliance() ? true : router.createUrlTree(['/assessment']);
};
